export const color = {
  gray: '#979797',
  blue: '#0054FC',
};

export const mobNavBarHeight = '88rem';

export const pcNavBarHeight = '72rem';

export const mobFooterHeight = '132rem';

export const pcFooterHeight = '182rem';

// export const messageContainerHeight = `calc(100vh - ${mobNavBarHeight} - ${mobFooterHeight})`;
